import { render, staticRenderFns } from "./FormMarketingCampaignGeneralInfo.vue?vue&type=template&id=32495aea&scoped=true&"
import script from "./FormMarketingCampaignGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./FormMarketingCampaignGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./FormMarketingCampaignGeneralInfo.vue?vue&type=style&index=0&id=32495aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32495aea",
  null
  
)

export default component.exports